<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import { getFirestore, collection, updateDoc, serverTimestamp, doc  } from "firebase/firestore/lite"
import {firebase} from "../../../../../firebase-int";
import CryptoJS from 'crypto-js';

const firestore = getFirestore(firebase);
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from 'vuelidate/lib/validators'

const mustHaveTo = (value) => (value+'').indexOf(' to ') >= 0

export default {
  page: {
    title: 'Edit Event',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      dismissSecs: 2,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      alertMessage:'',
      successStatus:true,
      processingData:false,

      pvtData: "",
      secret: "123#$%",
      encData: "",

      title: 'Edit Event',
      items: [
        {
          text: 'Gebi',
          href: '/',
        },
        {
          text: 'Event',
          href: '/Event',
        },
        {
          text: 'Edit Event: '+this.$route.params.event.id,
          active: true,
        },
      ],
      
      form: {
        title: this.$route.params.event.title,
        description:this.$route.params.event.description,
        venue:this.$route.params.event.venue,
        fromDate:this.$route.params.event.fromDate,
        toDate:this.$route.params.event.toDate,
        dateValue:this.$route.params.event.date,
      },
      submit: false,
      submitted: false,
      formsubmit: false,
      typesubmit: false,

      
      calendarConfig: {
          wrap: true, 
          defaultDate:new Date(),
          dateFormat: 'd/m/Y h:i K',  
          mode: "range",
          minDate: "today",
          altInput: true,
          altFormat: "F j, Y h:i K",
          time_24hr: false,
          enableTime: true,   
        },
    }
  },
  validations: {
    form: {
      title: { required,  minLength: minLength(2) },
      description: { required,  minLength: minLength(5) },
      venue: { required,  minLength: minLength(2) },
      dateValue: { required, mustHaveTo},
    },
    
  },
  methods: {
    /**
     * Basic Form submit
     */
    handleSubmit(e) {
      this.submitted = true

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;
      this.updateIndustry();
    },

    async updateIndustry() {
      this.processingData=true;
      var index=this.form.dateValue.indexOf(' to ');
      if (index >= 0) { 
        //valid
        this.form.fromDate=this.form.dateValue.substring(0, index)
        this.form.toDate=this.form.dateValue.substring(index+4, this.form.dateValue.length)
      } 
      try {
            const docRef=doc(firestore, 'event', this.$route.params.event.id)
            await updateDoc(docRef, {
              title: this.form.title,
              description:this.form.description,
              venue:this.form.venue,
              fromDate:this.form.fromDate,
              toDate:this.form.toDate,
              date:this.form.dateValue,
              //created: serverTimestamp(),
              updated: serverTimestamp(),
              //createdBy: 'Creator User ID',
              updatedBy: this.$store.state.auth.currentUser.id,
            });
            //this.makeToast(false, "Document written with ID: ", docRef.id);
            this.successStatus=true;
            this.dismissSecs=2;
            this.alertMessage="Event updated with ID: "+ docRef.id;
            this.showAlert();
            console.log("Document written with ID: ", docRef.id);
            await this.addToLog('event modified', this.$store.state.auth.currentUser.id , docRef.id);
            //this.clearFields();
            setTimeout(() => {
              this.$router.push({ name: 'Event' })
            }, 2000)
          } catch (e) {
            console.error("Error updating document: ", e);
            this.successStatus=false;
            this.dismissSecs=4;
            this.alertMessage="Not able to update event data. Please try again.";
            this.showAlert();
            this.processingData=false;
          }
          //this.processingData=false;

      },
      clearFields()
      {
        this.form.name= 'Industry Name';
        this.form.description= 'Description goes here';
      },

      // alert related methods
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert() {
        this.dismissCountDown = this.dismissSecs
      },

      // encryption related methods
      encryptData(passwordData) {
        // return CryptoJS.AES.encrypt(JSON.stringify({ passwordData }), this.secret).toString();
        return CryptoJS.AES.encrypt(passwordData, this.secret).toString();
      },

      gotoEvents()
      {
        this.$router.push({ name: 'Event', params: { userId: '123' } });
      },
      
  },
  mounted()
  {
    //this.employerValue=this.employer[0];
    //this.sexValue=this.sex[0];
    //this.dobValue=Date.now();
    //this.regionValue=this.region[0];
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
      <b-alert v-if="successStatus" 
      :show="dismissCountDown"
      dismissible
      fade
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <p>{{ alertMessage }}</p>
    </b-alert>
    <b-alert v-else 
      :show="dismissCountDown"
      dismissible
      fade
      variant="danger"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      <p>{{ alertMessage }}</p>
    </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">Event Information</h4>
            <p class="sub-header"
              >Enter basic event information here.</p
            >
            <form @submit.prevent="handleSubmit">
              <div class="form-group">
                <label for="title">
                  Title
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="title"
                  v-model="form.title"
                  name="title"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.title.$error }"
                  type="text"
                  placeholder="Enter title"
                />
                <div
                  v-if="submitted && $v.form.title.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.title.required"
                    >This value is required.</span
                  >
                  <span v-if="!$v.form.title.minLength"
                    >Title must be at least 2 characters.</span
                  >
                </div>
              </div>
              <div class="form-group">
                <label>
                  Description
                  <span class="text-danger">*</span>
                </label>
                <textarea
                  v-model="form.description"
                  type="text"
                  rows="5"
                  name="description"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.description.$error,
                  }"
                  placeholder="Enter description"
                />
                <div
                  v-if="submitted && $v.form.description.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.description.required"
                    >This value is required.</span
                  >
                  <span v-if="!$v.form.description.minLength"
                    >Description must be at least 5 characters.</span
                  >
                </div>
              </div>


              <div class="form-group">
                <label>
                  Venue
                  <span class="text-danger">*</span>
                </label>
                <textarea
                  v-model="form.venue"
                  type="text"
                  rows="5"
                  name="venue"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.venue.$error,
                  }"
                  placeholder="Enter venue"
                />
                <div
                  v-if="submitted && $v.form.venue.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.venue.required"
                    >This value is required.</span
                  >
                  <span v-if="!$v.form.venue.minLength"
                    >Venue must be at least 2 characters.</span
                  >
                </div>
              </div>

              <div class="form-group mb-3">
                <label>Date
                  <span class="text-danger">*</span>
                </label>
                <flat-pickr
                  v-model="form.dateValue"
                  :config="calendarConfig"
                  class="form-control"
                  placeholder="Date"
                  name="dateValue"
                  :class="{
                    'is-invalid': submitted && $v.form.dateValue.$error,
                  }"
                ></flat-pickr>
                <div
                  v-if="submitted && $v.form.dateValue.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.dateValue.required"
                    >This value is required.</span
                  >
                  <span v-if="!$v.form.dateValue.mustHaveTo"
                    >Please select an appropriate date. (Eg. From Date x to Date Y)</span
                  >
                </div>
              </div>

              
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->

    </div>
    <!-- end row -->

    
    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
                  
            <!--form @submit.prevent="handleSubmit">
                  <button v-if='!processingData' type="submit" class="btn btn-primary"
                    >Save</button>
                  <button v-else disabled  class="btn btn-primary"
                  >Save</button>
                  <a href="/member">
                  <button class="btn btn-secondary m-l-5 ml-1"
                    >Cancel</button></a>
            </form-->
            <form @submit.prevent="handleSubmit">
            <template>
              <b-button :disabled="processingData" type="submit" variant="primary"><i class="uil uil-down-arrow mr-1"></i> Save Changes</b-button>
              <b-button variant="light" @click="gotoEvents" style="margin-left:10px;">Close</b-button>
									
								</template>
            </form>
                  
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    
  </Layout>
</template>
